export const getCentralCanterburyData = () => ({
  name: "Central Canterbury",
  region: "Canterbury",
  country: "Nouvelle-Zélande",
  description: "Central Canterbury est une sous-région viticole traditionnelle, connue pour ses vignobles établis et ses vins aromatiques. Les sols alluviaux et les microclimats variés favorisent la diversité des styles.",
  type: "subregion",
  area: "300 ha",
  production: "0.02 million hectolitres",
  climate: "Climat tempéré avec influences maritimes et alpines, étés frais et hivers froids",
  soil: "Sols alluviaux, bonne rétention d'eau, diversité géologique",
  characteristics: {
    climate: "Climat tempéré avec influences maritimes et alpines, étés frais et hivers froids",
    soil: "Sols alluviaux, bonne rétention d'eau, diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements contrôlés, diversité de cépages"
  },
  wineStyles: {
    white: "Sauvignon Blanc aromatique, Chardonnay frais, Gewürztraminer floral",
    red: "Pinot Noir fruité, tanins souples",
    rosé: "Rosés légers et fruités"
  },
  history: "Central Canterbury est l'une des plus anciennes zones viticoles de la région, avec une tradition de production de vins de qualité depuis les années 1980.",
  foodPairing: "Poissons, fruits de mer, fromages frais, plats locaux",
  grapeVarieties: [
    { name: "Sauvignon Blanc", percentage: "30%", description: "Vins aromatiques, acidité vive" },
    { name: "Chardonnay", percentage: "30%", description: "Vins frais, équilibrés" },
    { name: "Pinot Noir", percentage: "25%", description: "Vins rouges fruités, tanins souples" },
    { name: "Gewürztraminer", percentage: "10%", description: "Vins blancs floraux, aromatiques" },
    { name: "Autres", percentage: "5%", description: "Pinot Gris, expérimentaux" }
  ],
  statistics: {
    totalArea: "300 ha",
    production: "0.02 million hectolitres",
    wineries: "5+ domaines",
    exportPercentage: "20%"
  },
  viticulture: "La viticulture à Central Canterbury privilégie la diversité des cépages et la qualité. Les rendements sont modérés pour préserver la fraîcheur et l'aromatique.",
  winemaking: "La vinification se fait en cuves inox pour les blancs et en fûts pour les rouges. Les styles varient selon les producteurs.",
  terroir: "Central Canterbury est caractérisée par ses sols alluviaux et ses microclimats variés, permettant une grande diversité de styles et de cépages.",
  mapAreas: [
    { region: "Central Canterbury", x: 172.3, y: -43.7, color: "#8a4a8a", size: 2 }
  ]
}); 